import { Components, Theme } from "@mui/material";
import { Shades } from "../../../style/Colors";

export const MuiDivider: Components<Theme>["MuiDivider"] = {
  styleOverrides: {
    root: {
      marginTop: 15,
      marginBottom: 15,
      height: 2,
      color: Shades.gray40,
      backgroundColor: Shades.gray40,
    },
  },
};
